import styled, { keyframes } from 'styled-components'

const displayApplyButton = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const ApplyButtonWrapper = styled.div<{ isOpened: boolean }>`
  width: 100%;
  border-top: 0.1rem solid ${({ theme }) => theme.palette.whisper};
  position: fixed;
  bottom: 0;
  padding: 2.2rem;

  visibility: ${({ isOpened }) => (isOpened ? 'visible' : 'hidden')};
  animation: ${displayApplyButton} 0.3s ease-in-out forwards;
  background: ${({ theme }) => theme.palette.white};

  & button {
    position: relative;
    border-radius: none;
    font-weight: bold;
  }

  & svg {
    height: 1.6rem;

    position: absolute;
    right: 2rem;
    top: 1.25rem;
  }
`

export const ScrollViewContainer = styled.div.attrs({
  className: '',
})<{ isOpened?: boolean }>`
  background-color: inherit;
  transform: translateY(${(props) => (props.isOpened ? '0' : '-1rem')});
  opacity: ${(props) => (props.isOpened ? '1' : '0')};

  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
`
